module.exports = __webpack_public_path__ + "images/e60a27592264e9749500ff6bcdd5a7c8.png";


//////////////////
// WEBPACK FOOTER
// ./js/components/assets/woman/11.png
// module id = 387
// module chunks = 0